import { Link } from "react-router-dom";
import { SERVICES } from "../../lib/data/services";
import { CITIES } from "../../lib/data/cities";
import { ALL_CANADA_KEYWORDS } from "../../lib/data/canadaKeywords";

// Site-wide crawlable keyword footer.
// Renders low-emphasis, high-density Canadian security industry terms plus
// deep-linking to every service, city, and combo landing page.
// Preserves URLs. Small, subtle, Awwwards-friendly styling.
export default function KeywordFooter() {
  return (
    <section
      data-testid="keyword-footer"
      aria-label="Related security services and cities across British Columbia and Canada"
      className="bg-[#F4F4F0] border-t border-black/10 py-14 md:py-20"
    >
      <div className="mx-auto max-w-[1400px] px-6 lg:px-10">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10">
          <div className="md:col-span-3">
            <div className="font-mono text-[10px] tracking-[0.28em] uppercase text-[#D92323]">
              Canadian Security Index
            </div>
            <p className="mt-4 text-xs md:text-sm text-[#5C5F66] leading-relaxed">
              Maze Security Solutions serves every corner of British Columbia
              with province-wide dispatch, Canadian security industry
              certifications, and licensed operators across every discipline.
            </p>
          </div>

          <div className="md:col-span-9 space-y-8">
            <div>
              <div className="font-mono text-[10px] tracking-[0.28em] uppercase text-[#060913]/60 mb-3">
                Services · BC & Canada
              </div>
              <div className="flex flex-wrap gap-x-1 gap-y-1">
                {SERVICES.map((s) => (
                  <Link
                    key={s.slug}
                    to={`/services/${s.slug}`}
                    className="text-[11px] font-mono uppercase tracking-[0.12em] text-[#060913]/60 hover:text-[#D92323] px-2 py-1 border border-black/10 hover:border-[#D92323]"
                  >
                    {s.name}
                  </Link>
                ))}
              </div>
            </div>

            <div>
              <div className="font-mono text-[10px] tracking-[0.28em] uppercase text-[#060913]/60 mb-3">
                Cities · British Columbia
              </div>
              <div className="flex flex-wrap gap-x-1 gap-y-1">
                {CITIES.map((c) => (
                  <Link
                    key={c.slug}
                    to={`/cities/${c.slug}`}
                    className="text-[11px] font-mono uppercase tracking-[0.12em] text-[#060913]/60 hover:text-[#D92323] px-2 py-1 border border-black/10 hover:border-[#D92323]"
                  >
                    {c.name}
                  </Link>
                ))}
              </div>
            </div>

            <div>
              <div className="font-mono text-[10px] tracking-[0.28em] uppercase text-[#060913]/60 mb-3">
                Canadian Security Industry Keywords
              </div>
              <div className="text-[10.5px] font-mono uppercase tracking-[0.1em] text-[#060913]/40 leading-relaxed">
                {ALL_CANADA_KEYWORDS.join(" · ")}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
